import script from "./EmojiPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./EmojiPicker.vue?vue&type=script&setup=true&lang=ts"

import "./EmojiPicker.vue?vue&type=style&index=0&id=ff652cd4&scoped=true&lang=css"
import "./EmojiPicker.vue?vue&type=style&index=1&id=ff652cd4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff652cd4"]])

export default __exports__